module.exports = __webpack_public_path__ + "img/4.ffde5480.png";